import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const DOORDASH_URL = 'https://www.doordash.com/store/tacos-y-pupusas-t%C3%ADa-sandra-denton-29965951'

/**
 * OrderComingSoon — placeholder for the future Square-powered ordering flow.
 *
 * When Sandra is ready to take orders directly on the site, replace this
 * component's render with the order-build UI (menu item selector, cart,
 * customer info, Square payment form). Keep the route at '/order' so the
 * header's "Place an Order" button works without changes.
 *
 * Required additions at that time: Square Web Payments SDK dependency,
 * a thin backend endpoint to create the Square payment, and order state
 * (Context or a small useReducer — no Redux needed at this scope).
 */
function OrderComingSoon() {
  const { t } = useTranslation()

  return (
    <section className="section order-coming-soon" aria-labelledby="order-heading">
      <div className="container">
        <h1 id="order-heading">{t('order.heading')}</h1>
        <p className="order-body">{t('order.body')}</p>

        <div className="hero-cta-row">
          <a href="tel:+14694917604" className="btn-primary">
            {t('order.callCta')}
          </a>
          <a
            href={DOORDASH_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
          >
            {t('order.doordashCta')}
          </a>
        </div>

        <p className="order-back">
          <Link to="/" className="order-coming-soon-back">
            ← {t('order.backHome')}
          </Link>
        </p>
      </div>
    </section>
  )
}

export default OrderComingSoon
